import { type EditCampaignInputType } from '@shelflix/schemas/campaign/edit';
import { create } from 'zustand';

interface CampaignFormStore {
  formData: Partial<EditCampaignInputType>;
  setFormData: (data: Partial<EditCampaignInputType>) => void;
  resetForm: () => void;
}

export const useCampaignFormStore = create<CampaignFormStore>((set) => ({
  formData: {},
  setFormData: (data) => set((state) => ({ formData: { ...state.formData, ...data } })),
  resetForm: () => set({ formData: {} }),
}));
